/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AuthedRouteImport } from "./routes/_authed";
import { Route as MethodologyRouteImport } from "./routes/methodology";
import { Route as SignedOutRouteImport } from "./routes/signed-out";
import { Route as AuthedIndexRouteImport } from "./routes/_authed.index";
import { Route as AuthedCartRouteImport } from "./routes/_authed.cart";
import { Route as AuthedStandingOrdersRouteImport } from "./routes/_authed.standing-orders";
import { Route as AuthedTemplatesRouteImport } from "./routes/_authed.templates";
import { Route as TCodeRouteImport } from "./routes/t.$code";
import { Route as TransparencyYearRouteImport } from "./routes/transparency.$year";
import { Route as AuthedInvoicesIndexRouteImport } from "./routes/_authed.invoices.index";
import { Route as AuthedOrdersIndexRouteImport } from "./routes/_authed.orders.index";
import { Route as AuthedOrdersOrderIdRouteImport } from "./routes/_authed.orders.$orderId";

const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const MethodologyRoute = MethodologyRouteImport.update({
  id: "/methodology",
  path: "/methodology",
  getParentRoute: () => rootRouteImport,
} as any);
const SignedOutRoute = SignedOutRouteImport.update({
  id: "/signed-out",
  path: "/signed-out",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedCartRoute = AuthedCartRouteImport.update({
  id: "/cart",
  path: "/cart",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedStandingOrdersRoute = AuthedStandingOrdersRouteImport.update({
  id: "/standing-orders",
  path: "/standing-orders",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedTemplatesRoute = AuthedTemplatesRouteImport.update({
  id: "/templates",
  path: "/templates",
  getParentRoute: () => AuthedRoute,
} as any);
const TCodeRoute = TCodeRouteImport.update({
  id: "/t/$code",
  path: "/t/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const TransparencyYearRoute = TransparencyYearRouteImport.update({
  id: "/transparency/$year",
  path: "/transparency/$year",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedInvoicesIndexRoute = AuthedInvoicesIndexRouteImport.update({
  id: "/invoices/",
  path: "/invoices/",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedOrdersIndexRoute = AuthedOrdersIndexRouteImport.update({
  id: "/orders/",
  path: "/orders/",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedOrdersOrderIdRoute = AuthedOrdersOrderIdRouteImport.update({
  id: "/orders/$orderId",
  path: "/orders/$orderId",
  getParentRoute: () => AuthedRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute;
  "/methodology": typeof MethodologyRoute;
  "/signed-out": typeof SignedOutRoute;
  "/cart": typeof AuthedCartRoute;
  "/standing-orders": typeof AuthedStandingOrdersRoute;
  "/templates": typeof AuthedTemplatesRoute;
  "/t/$code": typeof TCodeRoute;
  "/transparency/$year": typeof TransparencyYearRoute;
  "/orders/$orderId": typeof AuthedOrdersOrderIdRoute;
  "/invoices/": typeof AuthedInvoicesIndexRoute;
  "/orders/": typeof AuthedOrdersIndexRoute;
}
export interface FileRoutesByTo {
  "/methodology": typeof MethodologyRoute;
  "/signed-out": typeof SignedOutRoute;
  "/cart": typeof AuthedCartRoute;
  "/standing-orders": typeof AuthedStandingOrdersRoute;
  "/templates": typeof AuthedTemplatesRoute;
  "/t/$code": typeof TCodeRoute;
  "/transparency/$year": typeof TransparencyYearRoute;
  "/": typeof AuthedIndexRoute;
  "/orders/$orderId": typeof AuthedOrdersOrderIdRoute;
  "/invoices": typeof AuthedInvoicesIndexRoute;
  "/orders": typeof AuthedOrdersIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authed": typeof AuthedRouteWithChildren;
  "/methodology": typeof MethodologyRoute;
  "/signed-out": typeof SignedOutRoute;
  "/_authed/cart": typeof AuthedCartRoute;
  "/_authed/standing-orders": typeof AuthedStandingOrdersRoute;
  "/_authed/templates": typeof AuthedTemplatesRoute;
  "/t/$code": typeof TCodeRoute;
  "/transparency/$year": typeof TransparencyYearRoute;
  "/_authed/": typeof AuthedIndexRoute;
  "/_authed/orders/$orderId": typeof AuthedOrdersOrderIdRoute;
  "/_authed/invoices/": typeof AuthedInvoicesIndexRoute;
  "/_authed/orders/": typeof AuthedOrdersIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/methodology"
    | "/signed-out"
    | "/cart"
    | "/standing-orders"
    | "/templates"
    | "/t/$code"
    | "/transparency/$year"
    | "/orders/$orderId"
    | "/invoices/"
    | "/orders/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/methodology"
    | "/signed-out"
    | "/cart"
    | "/standing-orders"
    | "/templates"
    | "/t/$code"
    | "/transparency/$year"
    | "/"
    | "/orders/$orderId"
    | "/invoices"
    | "/orders";
  id:
    | "__root__"
    | "/_authed"
    | "/methodology"
    | "/signed-out"
    | "/_authed/cart"
    | "/_authed/standing-orders"
    | "/_authed/templates"
    | "/t/$code"
    | "/transparency/$year"
    | "/_authed/"
    | "/_authed/orders/$orderId"
    | "/_authed/invoices/"
    | "/_authed/orders/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren;
  MethodologyRoute: typeof MethodologyRoute;
  SignedOutRoute: typeof SignedOutRoute;
  TCodeRoute: typeof TCodeRoute;
  TransparencyYearRoute: typeof TransparencyYearRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/methodology": {
      id: "/methodology";
      path: "/methodology";
      fullPath: "/methodology";
      preLoaderRoute: typeof MethodologyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signed-out": {
      id: "/signed-out";
      path: "/signed-out";
      fullPath: "/signed-out";
      preLoaderRoute: typeof SignedOutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/": {
      id: "/_authed/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthedIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/cart": {
      id: "/_authed/cart";
      path: "/cart";
      fullPath: "/cart";
      preLoaderRoute: typeof AuthedCartRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/standing-orders": {
      id: "/_authed/standing-orders";
      path: "/standing-orders";
      fullPath: "/standing-orders";
      preLoaderRoute: typeof AuthedStandingOrdersRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/templates": {
      id: "/_authed/templates";
      path: "/templates";
      fullPath: "/templates";
      preLoaderRoute: typeof AuthedTemplatesRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/t/$code": {
      id: "/t/$code";
      path: "/t/$code";
      fullPath: "/t/$code";
      preLoaderRoute: typeof TCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/transparency/$year": {
      id: "/transparency/$year";
      path: "/transparency/$year";
      fullPath: "/transparency/$year";
      preLoaderRoute: typeof TransparencyYearRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/invoices/": {
      id: "/_authed/invoices/";
      path: "/invoices";
      fullPath: "/invoices/";
      preLoaderRoute: typeof AuthedInvoicesIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/orders/": {
      id: "/_authed/orders/";
      path: "/orders";
      fullPath: "/orders/";
      preLoaderRoute: typeof AuthedOrdersIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/orders/$orderId": {
      id: "/_authed/orders/$orderId";
      path: "/orders/$orderId";
      fullPath: "/orders/$orderId";
      preLoaderRoute: typeof AuthedOrdersOrderIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
  }
}

interface AuthedRouteChildren {
  AuthedCartRoute: typeof AuthedCartRoute;
  AuthedStandingOrdersRoute: typeof AuthedStandingOrdersRoute;
  AuthedTemplatesRoute: typeof AuthedTemplatesRoute;
  AuthedIndexRoute: typeof AuthedIndexRoute;
  AuthedOrdersOrderIdRoute: typeof AuthedOrdersOrderIdRoute;
  AuthedInvoicesIndexRoute: typeof AuthedInvoicesIndexRoute;
  AuthedOrdersIndexRoute: typeof AuthedOrdersIndexRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCartRoute: AuthedCartRoute,
  AuthedStandingOrdersRoute: AuthedStandingOrdersRoute,
  AuthedTemplatesRoute: AuthedTemplatesRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedOrdersOrderIdRoute: AuthedOrdersOrderIdRoute,
  AuthedInvoicesIndexRoute: AuthedInvoicesIndexRoute,
  AuthedOrdersIndexRoute: AuthedOrdersIndexRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  MethodologyRoute: MethodologyRoute,
  SignedOutRoute: SignedOutRoute,
  TCodeRoute: TCodeRoute,
  TransparencyYearRoute: TransparencyYearRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
